import { AlertTriangle, PowerOff, Search } from "lucide-react";
import { Button } from "../ui/button";

/** Admin-only alert strip fed by the existing /admin/brain/agents status calculation (no second status system). */
export const AgentAlerts = ({ agents, onInvestigate, onOpen }) => {
  const alerts = agents.filter((a) => a.status === "ERROR" || a.status === "DISABLED");
  if (alerts.length === 0) return null;
  return (
    <div role="alert" className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 space-y-2" data-testid="agent-alerts">
      <p className="text-xs font-semibold uppercase tracking-widest text-amber-800 dark:text-amber-300" data-testid="agent-alerts-title">{alerts.length} agent{alerts.length > 1 ? "s" : ""} need{alerts.length > 1 ? "" : "s"} attention</p>
      <ul className="space-y-1.5">
        {alerts.map((a) => (
          <li key={a.agent_id} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`agent-alert-${a.agent_id}`}>
            {a.status === "ERROR" ? <AlertTriangle className="h-4 w-4 text-red-600 dark:text-red-400" strokeWidth={1.5} /> : <PowerOff className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />}
            <button type="button" className="font-medium hover:underline" onClick={() => onOpen(a.agent_id)} data-testid={`agent-alert-name-${a.agent_id}`}>{a.name}</button>
            <span className={`font-mono-tech text-[11px] px-1.5 py-0.5 rounded ${a.status === "ERROR" ? "bg-red-500/15 text-red-700 dark:text-red-300" : "bg-muted text-muted-foreground"}`} data-testid={`agent-alert-status-${a.agent_id}`}>{a.status}</span>
            <span className="text-xs text-muted-foreground" data-testid={`agent-alert-reason-${a.agent_id}`}>{a.status_reason}</span>
            <Button size="sm" variant="outline" className="h-7 text-xs rounded-full ml-auto" onClick={() => onInvestigate(a)} data-testid={`agent-alert-investigate-${a.agent_id}`}><Search className="h-3.5 w-3.5 mr-1" strokeWidth={1.5} />Investigate tasks</Button>
          </li>
        ))}
      </ul>
    </div>
  );
};
